function getRequestSenderKey(request) {
  if (!request) {
    return '';
  }
  const fromUserId = request.fromUserId !== undefined && request.fromUserId !== null ? String(request.fromUserId) : '';
  if (fromUserId) {
    return `id:${fromUserId}`;
  }
  const fromUserName = request.fromUserName || request.fromUserNickName || '';
  return fromUserName ? `name:${fromUserName}` : `request:${request.id || ''}`;
}

function getRequestSortValue(request) {
  const id = Number(request && request.id ? request.id : 0);
  const rawCreatedTime = request && request.createdTime;
  if (typeof rawCreatedTime === 'number' && Number.isFinite(rawCreatedTime) && rawCreatedTime > 0) {
    return rawCreatedTime;
  }
  const createdTime = rawCreatedTime ? Date.parse(rawCreatedTime) : 0;
  if (!Number.isNaN(createdTime) && createdTime > 0) {
    return createdTime;
  }
  return id;
}

function sortRequestsDesc(left, right) {
  const sortDiff = getRequestSortValue(right) - getRequestSortValue(left);
  if (sortDiff !== 0) {
    return sortDiff;
  }
  const rightId = Number(right && right.id ? right.id : 0);
  const leftId = Number(left && left.id ? left.id : 0);
  return rightId - leftId;
}

function pickLatestRequest(requests) {
  return requests.slice().sort(sortRequestsDesc)[0];
}

export function mergeFriendRequestsBySender(requests) {
  if (!Array.isArray(requests)) {
    return [];
  }
  const groupedMap = new Map();
  requests.forEach(request => {
    const key = getRequestSenderKey(request);
    if (!key) {
      return;
    }
    if (!groupedMap.has(key)) {
      groupedMap.set(key, []);
    }
    groupedMap.get(key).push(request);
  });
  const mergedRequests = [];
  groupedMap.forEach(groupRequests => {
    const latestRequest = pickLatestRequest(groupRequests);
    if (latestRequest) {
      mergedRequests.push(latestRequest);
    }
  });
  return mergedRequests.sort(sortRequestsDesc);
}

export function getPendingFriendRequestCount(requests) {
  return mergeFriendRequestsBySender(requests).filter(request => request.status === 0).length;
}
